import React from 'react';
import { CreateReport } from '../../../components';
import { paths } from '../../../routes';
import * as Yup from 'yup';

export const Forms: React.FC = () => {

    return (
        <CreateReport
            initialValues={{
                fieldReportsDto: {},
            }}
            themeShortCode={paths.bulletincomposition.themeShortCode || ''}
            otherFields={{
                'fieldReportsDto.agentType': {
                    type: 'radio',
                    label: 'fonction',
                    grid: 12,
                    options: [
                        {
                            value: 'Chef de Train',
                            label: 'Chef de Train',
                        },
                        {
                            value: 'Conducteur',
                            label: 'Conducteur',
                        },
                    ],
                },
                'fieldReportsDto.comment': {
                    type: 'text',
                    label: 'Commentaire',
                    multiline: true,
                    rows: 4,
                    rowsMax: 15,
                },
            }}
            validationSchema={Yup.object({
                serviceName: Yup.string().required('Ce champ est requis').nullable(),
                uicStationCode: Yup.string().required('Ce champ est requis').nullable(),
                fieldReportsDto: Yup.object({
                    agentType: Yup.string().required('Ce champ est requis'),
                    attachedPieces: Yup.array().required('Ce champ est requis'),

                })
            })}
        />
    );
};

export default Forms;
